import http from '../libs/http';
import utils from '../libs/util'
let Qiniu = require("qiniu-js");

let util = {};

util.getUUid = () => {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

util.initQiNiuWangEditor = (editor, token, projectName, url) => {
    editor.customConfig.uploadImgServer = url;
    editor.customConfig.uploadFileName = 'file';
    editor.customConfig.projectName = projectName;
    editor.customConfig.utils = utils;
    editor.customConfig.uploadImgParams = { token: token, key: '' }
    editor.customConfig.uploadImgHooks = {
        async customInsert(insertImg, result, editor) {
            // Message是iview的提示，可以用alert代替的
            if (result.error) { this.$Message.error('上传失败：' + result.error) } else {
                // 这个是在七牛的bucket主机地址，我免费用户，没有采用自定义域名
                editor.customConfig.uploadImgParams.key = projectName + util.getUUid();

                let fileToken = await http.get(`/getFileToken`, {});
                editor.customConfig.uploadImgParams.token = fileToken.data.fileToken;

                const host = 'https://wdqiniu.wandaicloud.com/';
                // key就是文件名，不带后缀，但是能够正常访问
                const url = host + result.key;
                insertImg(url);
                return true
            }
        }
    }
    return editor;
}

function printLog(title, info) {
    window.console && console.log(title, info);
}

util.isDigital=(obj)=> {
  let reg = /^[0-9]*$/;
  return reg.test(obj);
}

//个位数前补零
util.formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 生成yyyy-MM-dd HH:mm:ss 长日期格式
util.formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const t1 = [year, month, day].map(util.formatNumber).join('-')
  const t2 = [hour, minute, second].map(util.formatNumber).join(':')
  return `${t1} ${t2}`
}


util.changeTime = data => {
  const date=new Date(data)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const t1 = [year, month, day].map(util.formatNumber).join('-')
  const t2 = [hour, minute, second].map(util.formatNumber).join(':')
  return {
    date:t1,
    time:t2
  }
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js